import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { locationAdvantages } from '../data/mock';

const LocationSection = () => {
  return (
    <section id="location" className="py-24 bg-[#0d1f35]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#c9a961] text-sm font-semibold tracking-widest uppercase">Strategic Position</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mt-3 mb-6">Location Advantage</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mx-auto mb-6" />
          <p className="text-white/60 max-w-2xl mx-auto">Perfectly positioned in the heart of North Bangalore's growth corridor</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Map Image */}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/40">
            <img
              src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80"
              alt="Embassy Verde Location"
              className="w-full h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/80 to-[#0a1628]/20" />
            
            {/* Location Pin Overlay */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <div className="w-16 h-16 bg-[#c9a961] rounded-full flex items-center justify-center animate-pulse shadow-lg shadow-[#c9a961]/50">
                  <MapPin className="w-8 h-8 text-[#0a1628]" />
                </div>
                <div className="absolute -inset-4 border-2 border-[#c9a961]/50 rounded-full animate-ping" />
              </div>
            </div>

            {/* Location Label */}
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-4">
                <div className="flex items-center gap-3">
                  <Navigation className="w-5 h-5 text-[#c9a961]" />
                  <div>
                    <p className="text-white font-semibold">Embassy Springs Township</p>
                    <p className="text-white/60 text-sm">Devanahalli, North Bangalore</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Location Advantages List */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-8">Key Distances</h3>
            <div className="space-y-4">
              {locationAdvantages.map((item, index) => (
                <div
                  key={index}
                  className="group flex items-center gap-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-5 hover:bg-white/10 hover:border-[#c9a961]/30 transition-all duration-300"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-[#c9a961]/20 to-[#c9a961]/5 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:from-[#c9a961]/30 group-hover:to-[#c9a961]/10 transition-all">
                    <MapPin className="w-6 h-6 text-[#c9a961]" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white font-medium">{item.place}</p>
                  </div>
                  <div className="bg-[#c9a961]/20 rounded-full px-4 py-1">
                    <span className="text-[#c9a961] font-bold text-sm">{item.distance}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
